import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Icon from "../../Icon/Icon";
import { Device } from "../../../../components/device";

/*
<Accordion
  title="What is your return policy?"
  content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
/>
<Accordion
  title="Which languages do you support?"
  content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
  labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
/>
<Accordion
  title="Can I use a custom domain?"
  content="
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>"
  />
*/

/*
TO DO:
  - https://dev.to/jam3/how-to-prevent-xss-attacks-when-using-dangerouslysetinnerhtml-in-react-1464
*/

interface AccordionProps
{
    header: string;
}

const AccordionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 48rem;
    &:before,
    &:after {
      content: "";
      width: 100%;
      height: 1px;
      background-color: currentColor;
      opacity: .25;
    }
    &:after {
      opacity: 0;
    }
    &:last-child {
      &:after {
        opacity: .25;
      }
    }
`;

const AccordionButton = styled.button`
    font-size: 1.15rem;
    cursor: pointer;
    padding: 1rem 2rem;
    display: flex;
    align-items: center;
    border: none;
    outline: none;
    font-weight: 500;
    text-align: left;
    position: relative;
    user-select: none;
    opacity: 0.85;
    transition: opacity 0.3s ease;
    ${Device.mobileMax} {
      font-size: 1rem;
    }
    &:focus {
      outline: none;
      opacity: 1;
    }
    > span {
      position: absolute;
      left: 0;
    }
    &:hover,
    &.accordion--active {
      opacity: 1;
    }
`;

const AccordionContent = styled.div `
    overflow: hidden;
    transition: max-height 0.4s ease;
    margin: 0 2rem 0 2rem;
    font-size: .9rem;
    p {
      margin-bottom: .5rem;
    }
    a {
      text-decoration: underline;

      &:hover {
        color: #989898;
      }
    }
`;

const AccordionContentBottomSpacer = styled.div`
    margin-top: 1rem;
`;

const Accordion: React.FunctionComponent<AccordionProps> = (props) =>
{

    const [activeState, setActiveState] = useState(false);
    const [heightState, setHeightState] = useState("0px");
    const content = React.createRef<HTMLDivElement>();

    useEffect(() =>
    {
        if (content.current)
        {
            setHeightState(!activeState ? "0px" : `${content.current.scrollHeight}px`);
        }
    }, [activeState, content]);

    const toggleAccordion = () =>
    {
        setActiveState(!activeState);
    };

    return(
        <AccordionWrapper {...props}>
            <AccordionButton className={`${activeState ? "accordion--active" : ""}`} onClick={toggleAccordion}>
                {!activeState ?
                    <Icon name="plus" className="mr-4 w-3 h-3" /> :
                    <Icon name="minus" className="mr-4 w-3 h-3" />
                }
                {props.header}
            </AccordionButton>
            <AccordionContent ref={content} style={{ maxHeight: `${heightState}` }}>
                {props.children}
                <AccordionContentBottomSpacer />
            </AccordionContent>
        </AccordionWrapper>
    );
};

export default Accordion;